import React, { useEffect, useContext, useState, useRef } from "react";
import $ from "jquery";
import {
  _t,
  managePageHrefLink,
  checkPermission,
  managePageHrefLinkMobile,
} from "../../../../functions/Functions";

import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";

const AuditSidebar = () => {
  const { t } = useTranslation();
  const { flag, setFlag } = useContext(SettingsContext);
  let { authUserInfo } = useContext(UserContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [matchCount, setMatchCount] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    handleJquery();
    $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();
    if (!term) {
      $(".fk-pos-nav > .fk-pos-nav__list").show();
      $(".fk-pos-nav__sub-list").show();
      $(".fk-sm-nav__bar > .fk-sm-nav__list").show();

      $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").children(".fk-pos-nav__sub").show();
        } else {
          $(this).removeClass("active").children(".fk-pos-nav__sub").hide();
        }
      });
      setMatchCount(null);
      return;
    }

    let count = 0;
    $(".fk-pos-nav > .fk-pos-nav__list-has-sub").each(function () {
      const $category = $(this);
      const catName = $category.children("a").text().toLowerCase();
      const isCatMatch = catName.includes(term);
      let categoryHasMatches = false;

      $category.children(".fk-pos-nav__sub").children(".fk-pos-nav__sub-list").each(function () {
        const $item = $(this);
        const itemText = $item.text().toLowerCase();

        if (isCatMatch || itemText.includes(term)) {
          $item.show();
          categoryHasMatches = true;
          count++;
        } else {
          $item.hide();
        }
      });

      if (categoryHasMatches || isCatMatch) {
        $category.show().addClass("active");
        $category.children(".fk-pos-nav__sub").show();
      } else {
        $category.hide();
      }
    });

    $(".fk-sm-nav__bar > .fk-sm-nav__list").each(function () {
      const $item = $(this);
      const itemText = $item.text().toLowerCase();
      if (itemText.includes(term)) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    setMatchCount(count);
  }, [searchTerm]);

  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
      $(this).attr("data-default-active", "true").siblings().removeAttr("data-default-active");
    });
  };

  const renderSearchBar = (isMobile = false) => (
    <div className={`manage-sidebar-search-box ${isMobile ? "mb-3" : "mb-2"}`}>
      <div className="manage-sidebar-search-wrapper">
        <span className="manage-sidebar-search-icon">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          ref={isMobile ? null : searchInputRef}
          type="text"
          className="form-control manage-sidebar-search-input"
          placeholder={_t(t("Search menus..."))}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setSearchTerm("");
            }
          }}
        />
        {searchTerm && (
          <button
            type="button"
            className="manage-sidebar-search-clear"
            onClick={() => {
              setSearchTerm("");
              if (!isMobile && searchInputRef.current) {
                searchInputRef.current.focus();
              }
            }}
            title={_t(t("Clear search"))}
          >
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        )}
      </div>
      {searchTerm.trim() && (
        <div className="manage-sidebar-search-meta d-flex justify-content-between align-items-center mt-1 px-1">
          <span className="badge badge-light manage-sidebar-badge">
            {matchCount !== null && (
              <>
                {matchCount}{" "}
                {matchCount === 1 ? _t(t("menu found")) : _t(t("menus found"))}
              </>
            )}
          </span>
          <button
            type="button"
            className="btn btn-link p-0 manage-sidebar-clear-link"
            onClick={() => setSearchTerm("")}
          >
            {_t(t("Clear"))}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <style>{`
        .manage-sidebar-search-box {
          position: relative;
          width: 100%;
        }
        .manage-sidebar-search-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1.5px solid #d1d5db;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          overflow: hidden;
        }
        .manage-sidebar-search-wrapper:focus-within {
          border-color: #0a8d6e;
          box-shadow: 0 0 0 3px rgba(10, 141, 110, 0.15);
        }
        .manage-sidebar-search-icon {
          position: absolute;
          left: 11px;
          color: #0a8d6e;
          font-size: 13px;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .manage-sidebar-search-input {
          width: 100% !important;
          height: 38px !important;
          border: none !important;
          background: transparent !important;
          padding-left: 33px !important;
          padding-right: 30px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .manage-sidebar-search-input::placeholder {
          color: #94a3b8 !important;
          font-size: 12.5px !important;
        }
        .manage-sidebar-search-clear {
          position: absolute;
          right: 8px;
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 1;
          z-index: 2;
          transition: color 0.15s ease;
        }
        .manage-sidebar-search-clear:hover {
          color: #ef4444;
        }
        .manage-sidebar-badge {
          background-color: #e6f4ea !important;
          color: #0a8d6e !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          padding: 3px 8px !important;
          border-radius: 12px !important;
        }
        .manage-sidebar-clear-link {
          font-size: 11px !important;
          color: #64748b !important;
          text-decoration: none !important;
        }
        .manage-sidebar-clear-link:hover {
          color: #ef4444 !important;
          text-decoration: underline !important;
        }
        .manage-sidebar-scroll {
          height: calc(100vh - 170px) !important;
          max-height: calc(100vh - 170px) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar {
          width: 6px !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2) !important;
          border-radius: 4px !important;
        }
        .manage-sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.35) !important;
        }
      `}</style>

      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            {renderSearchBar(true)}
            <div className="fk-sm-nav" data-simplebar>
              <ul className="t-list fk-sm-nav__bar flex-row">
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "MS RCR Question" // Keeping Manage for now as agreed
                  ) ? managePageHrefLinkMobile(
                  "/dashboard/audit/rcr-question-list",
                  _t(t("Audit Questions"))
                ) : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "MS RCR Audit"
                  ) ? managePageHrefLinkMobile(
                  "/dashboard/audit/rcr-list",
                  _t(t("Audits"))
                ) : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(
                    authUserInfo.permissions,
                    "MS RCR Audit"
                  ) ? managePageHrefLinkMobile(
                  "/dashboard/audit/rcr-leaderboard",
                  _t(t("Audit Leaderboard"))
                ) : ""}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation for Large Screen  */}
      <div className="d-none d-lg-block">
        {renderSearchBar(false)}
        <div className="fk-pos-nav manage-sidebar-scroll">
          <ul className="t-list fk-pos-nav__bar">
            {/* Audit */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub active`}
              data-default-active="true"
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Audit Management"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group" style={{ display: 'block' }}>
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "MS RCR Question") &&
                  managePageHrefLink(
                    "/dashboard/audit/rcr-question-list",
                    _t(t("Audit Questions"))
                  )}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "MS RCR Audit") &&
                  managePageHrefLink(
                    "/dashboard/audit/rcr-list",
                    _t(t("Audits"))
                  )}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "MS RCR Audit") &&
                  managePageHrefLink(
                    "/dashboard/audit/rcr-leaderboard",
                    _t(t("Audit Leaderboard"))
                  )}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AuditSidebar;
